import styled from 'styled-components'

import { ChartAnnotation } from '@/components/elements/ChartAnnotation'
import { Line } from '@/components/elements/Line'
import { Spacer } from '@/components/elements/Spacer'
import { Table } from '@/components/layouts/Ir/Mpocket/THDTable'
// import { Paragraph } from '@/components/enlayouts/Ir/Paragraph'

export const ForecastTable = () => {
  return (
    <>
    {/*
      <Paragraph>
        2023年6月期（2022年7月1日から2023年6月30日）における当社グループの連結業績予想は、次のとおりであります。
      </Paragraph>
      */}
      <Spacer h={{ sp: 30, pc: 60 }} />
      {/* <!--IRPOCKET 2601追記--> */}
      <div id="irp-highlight-table-forecastexten"></div>
      {/* <!--/IRPOCKET 2601追記--> */}
      <section>
        <Title id="irp-highlight-table-forecast1_en" />
        <Spacer h={{ sp: 10, pc: 22 }} />
        <Line color="grey" weight={1} direction="horizon" />
        <Spacer h={{ sp: 30, pc: 50 }} />
        <Annotation>
          <ChartAnnotation id="irp-highlight-table-forecast2_en" />
          {/* <ChartAnnotation>（百万円 / %）</ChartAnnotation> */}
        </Annotation>
        <Spacer h={{ sp: 6, pc: 10 }} />
        <TableWrapper id="irp-highlight-table-forecast3_en" content="ir-financial-forecast_en"/>
      </section>
      <Spacer h={{ sp: 50, pc: 80 }} />
      <section>
        <Title id="irp-highlight-table-forecast4_en" />
        <Spacer h={{ sp: 10, pc: 22 }} />
        <Line color="grey" weight={1} direction="horizon" />
        <Spacer h={{ sp: 30, pc: 50 }} />
        <Annotation>
          <ChartAnnotation id="irp-highlight-table-forecast5_en" />
        </Annotation>
        <Spacer h={{ sp: 6, pc: 10 }} />
        <TableWrapper id="irp-highlight-table-forecast6_en" content='ir-financial-forecast_en'/>
      </section>
    </>
  )
}

const Title = styled.h1`
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;

  @media screen and (max-width: 1047px) {
    font-size: 19px;
  }
`

const Annotation = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`

const TableWrapper = styled(Table)`
  > table {
    > thead {
      > tr:first-of-type > th {
        width: 33.3%;
      }
    }
    > tbody {
      > tr > th:first-of-type {
        width: 33.3%;
      }
    }
  }
`
